import React from 'react';
import { useFieldAttributes } from '../../services/field-attributes';
import { FieldLabelWUT } from '../field-label/field-label-wut';
import { DatePickerInputWUT } from './date-picker-input/date-picker-input-wut';
import { FieldErrorWUT } from '../field-error/field-error-wut';
import { FieldDescriptionWUT } from '../field-description/field-description-wut';
export const DatePickerFieldWUT = _ref => {
  let {
    fieldType,
    id,
    target,
    label,
    hideLabel,
    placeholder,
    required,
    description,
    value,
    onChange,
    onFocus,
    onBlur,
    hasError = false,
    errorMessage,
    error,
    validation,
    FieldLayout,
    firstDayOfWeek,
    availability,
    disabled,
    requiredIndicatorType,
    requiredIndicatorPlacement
  } = _ref;
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabelWUT, {
      labelId: labelId,
      htmlFor: inputId,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement
    }),
    renderInput: () => /*#__PURE__*/React.createElement(DatePickerInputWUT, {
      fieldType: fieldType,
      inputId: inputId,
      ariaDescribedBy: ariaDescribedBy,
      label: label,
      placeholder: placeholder,
      required: required,
      value: value,
      onChange: onChange,
      onBlur: onBlur,
      onFocus: onFocus,
      hasError: hasError,
      validation: validation,
      firstDayOfWeek: firstDayOfWeek,
      availability: availability,
      disabled: disabled,
      fieldId: id
    }),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }))
  });
};
//# sourceMappingURL=date-picker-field-wut.js.map